import { useLocation } from 'react-router-dom'
import moment from 'moment-timezone'
import { RESCHEDULE_VISIT_PAGE_PATH } from '../../../utils/constants'
import { DATE_FORMAT_SLASH } from '../../../utils/dateUtils'
import { getAddressStringFromAddressObject, getAge } from '../../../utils/common'

export const useInitialPatientInformation = () => {
  const { pathname, state = {} } = useLocation()
  const isReschedulePage = pathname === RESCHEDULE_VISIT_PAGE_PATH

  const initialValuesConfig = {
    patientFullNameInitial: '',
    dobTextInitial: '',
    emailTextInitial: '',
    addressTextInitial: '',
    phoneNumberTextInitial: '',
    phoneCountryInitial: 'us',
    phoneCountryCodeInitial: '1',
  }

  if (isReschedulePage) {
    initialValuesConfig.patientFullNameInitial = state?.patient?.fullName
    initialValuesConfig.emailTextInitial = state?.patient?.email
    initialValuesConfig.phoneCountryInitial = state?.patient?.phoneNumber?.CountryCode?.toLowerCase()
    initialValuesConfig.phoneCountryCodeInitial = state?.patient?.phoneNumber?.Prefix?.slice(1)
    initialValuesConfig.addressTextInitial = getAddressStringFromAddressObject(state?.patient?.address)

    initialValuesConfig.dobTextInitial = `${moment(state?.patient?.birthDate).format(
      DATE_FORMAT_SLASH,
    )} (${getAge(state?.patient?.birthDate)}/${state?.patient.gender === 'male' ? 'M' : 'F'})`

    initialValuesConfig.phoneNumberTextInitial = state?.patient?.phoneNumber?.Number?.slice(
      state?.patient?.phoneNumber?.Prefix?.length,
    )
  }

  return initialValuesConfig
}
